import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function BannerCarousel({ banners }) {
  const [idx, setIdx] = useState(0);
  const timer = useRef(null);
  const count = banners?.length || 0;

  useEffect(() => {
    if (count <= 1) return;
    timer.current = setInterval(() => setIdx((i) => (i + 1) % count), 4500);
    return () => clearInterval(timer.current);
  }, [count]);

  if (!count) return null;

  const prev = () => setIdx((i) => (i - 1 + count) % count);
  const next = () => setIdx((i) => (i + 1) % count);
  const active = banners[idx];

  return (
    <div
      data-testid="banner-carousel"
      className="relative rounded-2xl overflow-hidden shadow-lg h-40 sm:h-52"
    >
      <img
        src={active.image}
        alt={active.title}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
        <div className="text-lg font-bold" style={{ fontFamily: "Outfit, sans-serif" }}>{active.title}</div>
        <div className="text-xs opacity-90">{active.subtitle}</div>
      </div>
      {count > 1 && (
        <>
          <button
            data-testid="banner-prev-btn"
            onClick={prev}
            className="absolute left-2 top-1/2 -translate-y-1/2 h-8 w-8 rounded-full bg-white/80 text-slate-800 flex items-center justify-center hover:bg-white transition-colors"
          >
            <ChevronLeft size={18} />
          </button>
          <button
            data-testid="banner-next-btn"
            onClick={next}
            className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8 rounded-full bg-white/80 text-slate-800 flex items-center justify-center hover:bg-white transition-colors"
          >
            <ChevronRight size={18} />
          </button>
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
            {banners.map((b, i) => (
              <span
                key={b.id || b.image || i}
                className={`h-1.5 rounded-full transition-all ${
                  i === idx ? "w-6 bg-white" : "w-2 bg-white/60"
                }`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
